import { IEmailNotification, ILandingZoneNotification } from '../../models/NotificationModels';
import { API_ROUTE } from '../ApiRoute';
import ApiService from '../ApiService';
import ApiServiceBase from '../ApiServiceBase';
import { ServerType, ServiceType } from '../ServiceType.data';

const tangraServiceType = ServiceType.None;

export class NotificationService {
  private readonly service: ApiServiceBase = new ApiService(tangraServiceType, ServerType.tangra);

  private readonly dcaBackendService: ApiServiceBase = new ApiService(tangraServiceType, ServerType.dcaBackend);

  public getLandingZoneNotifications():
    | Promise<ILandingZoneNotification[]>
    | ILandingZoneNotification[] {
    return this.service.get({ route: [API_ROUTE.NOTIFICATION] });
  }
  public getEmailNotifications(): Promise<IEmailNotification[]> | IEmailNotification[] {
    return this.dcaBackendService.get({ route: [API_ROUTE.ALERT] });
  }
}

const notificationService = new NotificationService();
export default notificationService;
